import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CustomInput from '@/components/CustomInput'
import  { JtTable } from '@/components/Ele'
import {elementConfig} from './libs/ele-config.js'
import { ESelect } from '@/components/Ele/eSelect';
import VueMatomo from 'vue-matomo'


import './libs/multiple-select.js'
import './directives/index';

import '@/assets/css/global.css';
import '@/assets/fonts/iconfont.css';
import '@/styles/index.scss'; // global css
import '@/styles/theme.scss';
import bus from './libs/bus.js'

import './icons' // icon
import './permission' // permission control





Vue.use(VueMatomo, {
    host: process.env.VUE_APP_MATOMO_HOST,
    siteId: +process.env.VUE_APP_MATOMO_SITE_ID || 1,
});
// 导入默认的语言 vxe 

Vue.use(elementConfig);
Vue.component('CustomInput', CustomInput);
Vue.component('JtTable', JtTable);
Vue.component('ESelect', ESelect);

Vue.config.productionTip = false;
Vue.prototype.$backToTop = () => {
    let $html = document.querySelector('html');
    if($html){
        $html.scrollTop = 0;
        console.log('back to top~');
    }
};
if (process.env.NODE_ENV === 'production' && process.env.VUE_APP_IS_TEST !== 'true') { 
    console.log = new Function()
    console.error = new Function()
    console.warn = new Function()
    console.info = new Function()
    console.debug = new Function()
    console.log = new Function()
}
Vue.prototype.$bus = bus;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
